import { useMemo } from "react"
import { Toggle } from "web/components"
import { ExportButton } from "web/components"

import SettingsButton from "./SettingsButton"

export default function ComparisonControls({ view, comparisonData }) {
  const listType = "view_comparison"
  const { comparison } = view

  const {
    can_show_averages: canShowAverages,
    can_show_variances: canShowVariances,
    can_show_variance_percentages: canShowVariancePercentages,
  } = comparisonData

  const enabledToggles = useMemo(() => {
    const toggles = [
      { name: "show_averages", label: "Average", canShow: canShowAverages },
      { name: "show_variances", label: "Variance", canShow: canShowVariances },
      {
        name: "show_variance_percentages",
        label: "Variance %",
        canShow: canShowVariancePercentages,
      },
    ]
    return toggles.filter((item) => item.canShow)
  }, [canShowAverages, canShowVariances, canShowVariancePercentages])

  async function onToggleChange(value, name) {
    await view.updateComparison({ [name]: value })
  }

  function onToggleShowAll() {
    const localData = { ...comparisonData, show_all: !comparison.show_all }
    view.updateComparison({ show_all: !comparison.show_all }, localData)
  }

  return (
    <div className="ml-auto mt-2 flex items-center border-b pb-2">
      <div className="flex flex-col">
        <h2 className="font-medium text-gray-500 md:text-xl">Comparison</h2>

        <div className="mt-3 flex pb-1">
          <div className="flex items-center">
            {!!enabledToggles.length &&
              enabledToggles.map(({ name, label }, index) => (
                <div key={index} className="mr-4">
                  <Toggle
                    id={`toggle-${name}`}
                    label={label}
                    checked={!!comparison[name]}
                    onClick={(value) => {
                      onToggleChange(value.target.checked, name)
                    }}
                  />
                </div>
              ))}
          </div>
        </div>
      </div>
      <div className="ml-auto flex flex-col items-end">
        <div className="mb-2 ml-auto flex">
          <ExportButton view={view} listType={listType} onlyExcel />
          <SettingsButton viewId={view.id} viewType={view.type} />
        </div>
        <div className="ml-1">
          <Toggle
            id="toggle-selected"
            label={"Show All"}
            checked={comparison.show_all}
            onClick={onToggleShowAll}
          />
        </div>
      </div>
    </div>
  )
}
